<template>
    <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
      <v-row class="pa-2 customer" :style="{ marginBottom: role < 6 ? '10px' : '0px' }">
        <v-col cols="9" class="py-0 d-flex align-center ga-5">
          <h2 class="clientname">Factories</h2>
          <TemplateDownload v-if="role < 6" :data="excelTemplate" text="factories"/>
        </v-col>
        <v-col cols="3" class="py-0 d-flex align-center justify-end">
            <!-- <ExcelUpload @uploaded="addCustomer" showCard="product"/> -->
            <v-btn v-if="role < 6" class="ml-3" color="primary" variant="outlined" @click="startSync">
                  <v-icon left :class="{ 'rotating': isSyncing }">mdi-sync</v-icon>
                  {{ isSyncing ? 'Syncing' : 'Sync' }}
            </v-btn>             
            <ExcelUpload v-if="role < 6" @uploaded="addCustomer" showCard="customer"/>
            <!-- <Export :data="factoriesDetails" text="Factories"/> -->
        </v-col>
      </v-row>
      <div class="pa-2 table-container" style="height: 100%; width: 100%; overflow-x: auto;">
        <Table v-if="headers.length>0" @dialogs="edit" :title="'Factories'" :role="role" :headers="headers" :dataList="factoriesDetails" />
        <!-- <Table @dialogs="edit" v-else-if="factoriesDetails.length = 0" :title="'Factories'" :headers="headers" :dataList="factoriesDetails" /> -->
      </div>
    </v-card>
    <v-dialog v-model="factoriesDialog" width="800">
      <FactoriesForm @update-location="updateLocation" :index="index" :viewType="viewType" :designation="'Factories'" :customerForm="factoriesForm"  @close="close"/>
    </v-dialog>
  </template>
  
  <script>
import ExcelUpload from '@/menus/ExcelUpload.vue';
import DatamodelDetailsService from '@/api/service/DataModelDetails/DataModelsDetailsService';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import TemplateDownload from '@/menus/TemplateDownload.vue';
// import Export from '@/menus/Export.vue';
import Table from '@/menus/Table.vue'
import moment from 'moment';
import FactoriesForm from './FactoriesForm.vue';


  export default {
    components: {
      ExcelUpload,
      FactoriesForm,
      Table,
      // Export,
      TemplateDownload
    },
    data() {
      return {
        headers:[],
        isSyncing: false,
        factoriesDialog:false,
        factoriesForm:[],
        factory:[],
        factoriesDetails:[],
        user_id:null,
        user_name:null,
        role:null,
        excelTemplate:[]
      }
    },
    created() {
        this.getOrganisation();
        this.getModeldata();
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        this.user_name = user.username
        this.role = user.roles.role_type
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        async getModeldata(){
            try {
              let res = await DatamodelDetailsService.findAll({model_id:23,column_required:1})
              console.log(res,"res!!###")
              this.headers = res || []
              this.headers.forEach((item)=>{
                item.minWidth='200px'
                item.title = item.label
                item.value = item.column_name
                this.excelTemplate.push(item.column_name)
              })
              this.headers.push({ title: "Actions", value: 'actions', minWidth: '150px',})
              console.log(this.headers,"this.headers")
            } catch (error) {
              console.log(error)
            }
        },
        startSync() {
          this.isSyncing = true;
          setTimeout(() => {
            this.isSyncing = false;
          }, 4000);
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            this.factoriesDetails = this.organisationData && this.organisationData.factories ? this.organisationData.factories : this.factoriesDetails
        },

        close() {
            this.factoriesDialog = false
        },

        async save() {
            console.log("tttt!!!")
            this.organisationData.factories = this.factoriesDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id:this.$route.query.id
            }
            await clientDetailsService.update($data)
        },
        async edit($edit,bool,viewType,index){
          this.factoriesDialog=true
          this.factoriesForm = $edit
          this.viewType = viewType
          this.index = index
          console.log("$edit !!",$edit,bool,viewType,index)

        },
        addCustomer($data){
            this.factoriesDetails = $data
            let count = 0
            if(this.organisationData && this.organisationData.factories && Array.isArray(this.organisationData.factories)){
              count = this.organisationData.factories.length
            }
            for(let i of this.factoriesDetails){
              const now = moment().format('YYYY-MM-DD HH:mm:ss')
                i.id = ++count
                i.created = now
                i.modified = null
                i.created_by = this.user_id  
                i.modified_by = null
                i.active = 1
                i.deleted = 0
                i.deleted_by = null
              console.log(i ,"loop")
            }
            this.save()
        console.log($data,'geufeu')
        },
        updateLocation(data,index,type){
          console.log(data,"updatelocation !!")
            if(type == 'edit'){
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id
                data.modified_name = this.user_name
                this.factoriesDetails[index] = data
                this.save()
            }

        },
    }
  };
  </script>
  
  <style scoped>
  .customer{
    display: flex;
    align-items: center;
  }
  .upload-btn {
  /* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
  color: white;
  font-weight: 600;
  text-transform: none; /* keep 'Upload' normal instead of uppercase */
  border-radius: 12px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}
  .clientname {
    font-size: 20px;
    font-weight: 600;
  }
  
  .table-container {
    width: 100%;
     /* background: #ebf1f35a; */
    background: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    /* // border: 1px solid #d2d2d2; */

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 10px;

        thead {
        border: 1px solid #cbf0fd;
        background-color: #e3f2fd;

        th {
            font-size: 1rem;
            font-weight: 500;
            padding: 12px;
            text-align: left;
            color: #000;
        }
        }

        tbody {
        tr {
            cursor: pointer;
            font-size: 0.9rem;
            font-weight: 500;
            position: relative;
            overflow: hidden;
            border: 1px solid #cbf0fd;
            border-radius: 8px;

            &:nth-child(odd) {
            background-color: #ebf1f3;
            }

            &:nth-child(even) {
            background-color: #d9dbdb;
            }

            td {
            padding: 10px;
            text-align: left;
            color: #333;
            }

            &:hover {
            background-color: #f5f5f5;
            }
        }
        }
    }
    }
    .edit-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    }

    .noWrap{
    text-wrap:nowrap;
    }
    .no-data-container{
    display:flex;
    justify-content:center;
    align-items:center;
    width: 100%;
    height:400px;
    font-size:20px; 
    font-weight:500;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    .rotating {
      animation: spin 1s linear infinite;
    }
  </style>